import { ApiHandler, ApiHandlerWithArgs, ApiHandlerWithData, ApiResponseContext } from '~/plugins/apiClient/_types';
import api from '~/plugins/apiClient';
import { formatApiUrl } from '~/plugins/apiClient/utils';
import { FetchListOptions, PaginationMetaSchema } from '~/api/_types';
import {
    FetchTranslationGroupsResponse,
    FetchTranslationGroupsResponseSchema,
    FetchTranslationsResponse,
    FetchTranslationsResponseSchema,
    TranslationFormData,
    TranslationInfo,
    TranslationInfoSchema,
} from './_types';
import { transformZodSchemaFn } from '~/plugins/zod/utils';
import { transformFetchListOptionsToQuery } from '../_transformers';
import { rawToTranslationObject } from './_transformers';

const apiEndpointPrefix = 'translations';

export const fetchTranslationsRequest: ApiHandlerWithArgs<
    FetchListOptions,
    ApiResponseContext<FetchTranslationsResponse | null>
> = async (opt) => {
    const url = formatApiUrl(apiEndpointPrefix);
    return api.get(url, {
        transform: transformZodSchemaFn(FetchTranslationsResponseSchema, url),
        transformMeta: transformZodSchemaFn(PaginationMetaSchema, url),
        params: transformFetchListOptionsToQuery(opt),
    });
};

export const putTranslationRequest: ApiHandlerWithData<
    { displayId: number; data: TranslationFormData },
    ApiResponseContext<TranslationInfo | null, TranslationFormData>
> = async ({ displayId, data }) => {
    const url = formatApiUrl(apiEndpointPrefix, displayId);
    return api.put(url, data, {
        transform: transformZodSchemaFn(TranslationInfoSchema, url),
    });
};

export const getTranslation: ApiHandlerWithData<
    {
        locale: string;
        opt?: FetchListOptions;
    },
    ApiResponseContext<object | null, string, null>
> = async (args: { locale: string; opt?: FetchListOptions }) => {
    return api.get(formatApiUrl(apiEndpointPrefix, `all/${args.locale}`), {
        transform: rawToTranslationObject,
    });
};

export const fetchTranslationGroupsRequest: ApiHandler<
    ApiResponseContext<FetchTranslationGroupsResponse | null>
> = async () => {
    const url = formatApiUrl(apiEndpointPrefix, 'groups');
    return api.get(url, {
        transform: transformZodSchemaFn(FetchTranslationGroupsResponseSchema, url),
    });
};
